"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGtmEvent = exports.handleAdvertisingClick = exports.getGtmEventTrackingDataAttributes = exports.getTrackingAttributes = exports.AnalyticsCategoryType = void 0;
// TODO: Review event categories in PH-376
var AnalyticsCategoryType;
(function (AnalyticsCategoryType) {
    AnalyticsCategoryType["AboutUsPage"] = "about-us-page";
    AnalyticsCategoryType["Advertising"] = "advertising";
    AnalyticsCategoryType["CarFinder"] = "car-finder";
    AnalyticsCategoryType["ClassifiedsLandingPage"] = "clp";
    AnalyticsCategoryType["SearchResultsPage"] = "srp";
    AnalyticsCategoryType["ContactPage"] = "contact-page";
    AnalyticsCategoryType["DealerSignup"] = "dealer-signup";
    AnalyticsCategoryType["Editorial"] = "editorial";
    AnalyticsCategoryType["Footer"] = "footer";
    AnalyticsCategoryType["FooterNavigation"] = "footer-navigation";
    AnalyticsCategoryType["Homepage"] = "homepage";
    AnalyticsCategoryType["InternalServerErrorPage"] = "internal-server-error-page";
    AnalyticsCategoryType["Navigation"] = "navigation";
    AnalyticsCategoryType["News"] = "news";
    AnalyticsCategoryType["NewsArticle"] = "news-article-page";
    AnalyticsCategoryType["NewsLanding"] = "news-landing-page";
    AnalyticsCategoryType["NotFoundPage"] = "not-found-page";
    AnalyticsCategoryType["Forums"] = "forums";
    AnalyticsCategoryType["PopularForums"] = "popular-forums";
    AnalyticsCategoryType["PopularMakes"] = "popular-makes";
    AnalyticsCategoryType["PopularModels"] = "popular-models";
    AnalyticsCategoryType["PricingPolicyPage"] = "pricing-policy-page";
    AnalyticsCategoryType["PrivacyPolicyPage"] = "privacy-policy-page";
    AnalyticsCategoryType["RulesOfPostingPage"] = "rules-of-posting-page";
    AnalyticsCategoryType["SearchLandingPage"] = "slp";
    AnalyticsCategoryType["SellYourCar"] = "sell-your-car";
    AnalyticsCategoryType["ServiceUnavailablePage"] = "service-unavailable-page";
    AnalyticsCategoryType["SupportPage"] = "support-page";
    AnalyticsCategoryType["TermsAndConditionsPage"] = "terms-and-conditions-page";
    AnalyticsCategoryType["VehicleDetailsPage"] = "vdp";
})(AnalyticsCategoryType = exports.AnalyticsCategoryType || (exports.AnalyticsCategoryType = {}));
const getTrackingAttributes = (trackingAttributes) => {
    if (!trackingAttributes) {
        return undefined;
    }
    const { action, category, label, value } = trackingAttributes;
    return {
        'data-gtm-event-action': action,
        'data-gtm-event-category': category,
        'data-gtm-event-label': label,
        'data-gtm-event-value': value,
    };
};
exports.getTrackingAttributes = getTrackingAttributes;
const getGtmEventTrackingDataAttributes = ({ category, action, label, value, }) => ({
    'gtm.element.dataset.gtmEventAction': action,
    'gtm.element.dataset.gtmEventCategory': category,
    'gtm.element.dataset.gtmEventLabel': label,
    'gtm.element.dataset.gtmEventValue': value,
});
exports.getGtmEventTrackingDataAttributes = getGtmEventTrackingDataAttributes;
const handleAdvertisingClick = () => {
    // eslint-disable-next-line no-underscore-dangle
    const cmp = window.__tcfapi;
    if (cmp) {
        cmp('displayConsentUi', 2, () => null);
    }
};
exports.handleAdvertisingClick = handleAdvertisingClick;
const sendGtmEvent = (event, options) => {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event }, options));
};
exports.sendGtmEvent = sendGtmEvent;
//# sourceMappingURL=analyticsUtils.js.map